import { render, staticRenderFns } from "./addContact.vue?vue&type=template&id=3ff44bd8&scoped=true"
import script from "./addContact.vue?vue&type=script&lang=js"
export * from "./addContact.vue?vue&type=script&lang=js"
import style0 from "./addContact.vue?vue&type=style&index=0&id=3ff44bd8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff44bd8",
  null
  
)

export default component.exports